import { FooterContact } from './FooterContact';
import { FooterBrand } from './FooterBrand';

import { Link } from 'react-router-dom';
import { guadeloupeCity } from '../../data/mock';
import { citySlug } from '../../lib/citySlug';

export const FooterColumns = ({ handleWhatsAppClick }) => (
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            <FooterBrand />
            <div>
              <h3 className="text-xl font-bold text-red-600 mb-6">Services Principaux</h3>
              <ul className="space-y-3 text-gray-400">
                <li><Link data-testid="footer-retour-affectif-link" to="/retour-affectif-guadeloupe" className="hover:text-red-400 transition-colors">• Retour Affectif Rapide</Link></li>
                <li>• Sorcier Vaudou Authentique</li>
                <li>• Magie Blanche & Rouge</li>
                <li>• Magie Noire Discrète</li>
                <li><Link data-testid="footer-desenvoutement-link" to="/desenvoutement-guadeloupe" className="hover:text-red-400 transition-colors">• Désenvoutement Complet</Link></li>
                <li><Link data-testid="footer-voyance-link" to="/voyance-guadeloupe" className="hover:text-red-400 transition-colors">• Voyance & Médium</Link></li>
                <li>• Protection Spirituelle</li>
                <li>• Guérison Spirituelle</li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold text-red-600 mb-6">Villes Principales</h3>
              <ul className="space-y-3 text-gray-400">
                {guadeloupeCity.slice(0, 8).map((city) => (
                  <li key={citySlug(city)}>
                    <Link data-testid={`footer-city-link-${citySlug(city)}`} to={`/marabout/${citySlug(city)}`} className="hover:text-red-400 transition-colors">• Marabout {city}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <FooterContact handleWhatsAppClick={handleWhatsAppClick} />
          </div>
);
